document.addEventListener('DOMContentLoaded', function () {
    const sourceEl = document.querySelector('.product-form__buttons');
    const destinationEl = document.querySelector('.product__description');

    const callback = (mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length) {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        // sourceEl.removeChild(node);
                        destinationEl.appendChild(node);
                    }
                });
            }
        }
    };
    const observer = new MutationObserver(callback);

    observer.observe(sourceEl, {
        childList: true,
        subtree: true
    });

});